:host {
    display: block;

    .ti-navbar-nav {
        box-sizing: border-box;
        width: 100%;
        height: 64px;
        display: flex;
        align-items: stretch;
        margin: $polaris-space-2 0;
        background: $pl-container-background-color-secondary;
        border-top: 1px solid $pl-divider-color-secondary;
        border-bottom: 1px solid $pl-divider-color-secondary;
    }

    .ti-navbar-list {
        overflow-x: auto;
        overscroll-behavior-x: contain;
        scroll-snap-type: x mandatory;
        overflow-y: hidden;
        display: flex;
        align-items: baseline;
        width: 100%;
        margin: 0;
        padding: 0;
        box-sizing: border-box;

        &.ti-navbar-centered {
            margin: 0 auto;
        }
    }

    .ti-navbar-item {
        box-sizing: border-box;
        scroll-snap-align: none start;
        height: 100%;
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        background: 0;

        &:first-child {
            // padding to mimic ticom page layout margin madness
            padding-left: 14px;
        }

        &:last-child {
            // padding to mimic ticom page layout margin madness
            padding-right: 14px;

            .ti-navbar-item-label {
                border-width: 0;
            }
        }
    }

    .ti-navbar-item-label {
        text-decoration: none;
        color: $pl-text-color-secondary;
        padding: 0 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 25px;
        cursor: pointer;
        font-size: $polaris-font-paragraph-size-l;
        border-color: $pl-border-color-primary;
        border-style: solid;
        border-width: 0 1px 0 0;

        @include mix-for-sizes-down(phone) {
            font-size: $polaris-font-paragraph-size-m;
        }

        &:hover {
            text-decoration: underline;
            // no underline if not desktop - turn it off instead of on because
            // IE does not support the hover query and IE is only desktop
            @media (hover: none) {
                text-decoration: none;
            }
        }
    }

    .ti-navbar-item-active .ti-navbar-item-label {
        color: $pl-text-color-accent;
    }

    .ti-navbar-nav.ti-navbar-compact {
        height: 42px;
        margin: 0;

        .ti-navbar-nav {
            margin: 0;
        }
    }
}

// styles specific to being used for site header
:host([header]) {
    .ti-navbar-nav {
        height: 52px;
        margin: 0;
        border-top: 1px solid var(--_tiNavbar-borderColor, #{$polaris-palette-grey7});
        border-bottom: 1px solid var(--_tiNavbar-borderColor, #{$polaris-palette-grey7});
        background: var(--_tiNavbar-backgroundColor, rgba(0,0,0,0.8));
        backdrop-filter: blur(4px);
    }

    .ti-navbar-item-label {
        display: flex;
        align-items: center;
        height: 100%;
        color: $polaris-palette-white;
        border-width: 0;
        font-size: $polaris-font-size-2;

        &:is(:hover, :focus) {
            outline-offset: -4px;
            text-decoration: none;
            background-color: $polaris-palette-grey7;
        }
    }

    // .ti-navbar-item-active .ti-navbar-item-label {
    //     // background-color: $polaris-palette-grey7;
    //     border-bottom: 4px solid $polaris-palette-grey3;
    //     box-sizing: border-box;
    // }
}

:host(.ti-navbar-desktop) {
    .ti-navbar-nav .ti-navbar-list .ti-navbar-item-hidden {
        display: none;
    }
}

:host(.ti-navbar-phone) {
    .ti-navbar-nav .ti-navbar-list .ti-navbar-item {
        // padding to mimic ticom page layout margin madness
        &:first-child {
            padding-left: 2px;
        }

        &:last-child {
            padding-right: 2px;
        }
    }
}
